import http from '../helpers/http';

const Payroll = (token: string) => {
  const headers = {
    'x-access-token': token,
  };

  return {
    deductionCreate: async (body: any) => {
      const result = await http.post(`/deduction`, body, { headers });
      return result.data;
    },
    deductionCreateWithFile: async (body: FormData) => {
      const uploadHeaders = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-access-token': token,
        },
      };
      const result = await http.post(`/deduction/upload`, body, uploadHeaders);
      return result.data;
    },
    deductionApprove: async (deductionId: string) => {
      const result = await http.patch(`/deduction/${deductionId}/approve`, {}, { headers });
      return result.data;
    },
    deductionReject: async (deductionId: string) => {
      const result = await http.patch(`/deduction/${deductionId}/reject`, {}, { headers });
      return result.data;
    },
    deductionList: async (schoolId: string, _search = '', params?: Record<string, any>) => {
      const queryString = params ? `?${new URLSearchParams(params).toString()}` : '';
      const result = await http.get(`/cover-sheet/${schoolId}/deductions${queryString}`, {
        headers,
      });
      return result.data;
    },
    deductionFile: async (deductionId: string, body: FormData) => {
      const headers = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-access-token': token,
        },
      };
      const result = await http.patch(`/deduction/${deductionId}/file`, body, headers);
      return result.data;
    },
    extraPaymentCreate: async (body: any) => {
      const result = await http.post(`/extra-payment`, body, { headers });
      return result.data;
    },
    extraPaymentList: async (schoolId: string, _search = '', params?: Record<string, any>) => {
      const queryString = params ? `?${new URLSearchParams(params).toString()}` : '';
      const result = await http.get(`/extra-payment/by-school/${schoolId}${queryString}`, {
        headers,
      });
      return result.data;
    },
    extraPaymentDocument: async (extraPaymentId: string, body: FormData) => {
      const headers = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-access-token': token,
        },
      };
      const result = await http.patch(`/extra-payment/${extraPaymentId}/document`, body, headers);
      return result.data;
    },
    extraPaymentReceipt: async (extraPaymentId: string, body: FormData) => {
      const headers = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-access-token': token,
        },
      };
      const result = await http.patch(`/extra-payment/${extraPaymentId}/receipt`, body, headers);
      return result.data;
    },
    raiseCreate: async (body: any) => {
      const result = await http.post(`/raise`, body, { headers });
      return result.data;
    },
    raiseList: async (schoolId: string, _search = '', params?: Record<string, any>) => {
      const queryString = params ? `?${new URLSearchParams(params).toString()}` : '';
      const result = await http.get(`/cover-sheet/${schoolId}/raises${queryString}`, {
        headers,
      });
      return result.data;
    },
    raiseFile: async (extraPaymentId: string, body: FormData) => {
      const headers = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-access-token': token,
        },
      };
      const result = await http.patch(`/raise/${extraPaymentId}/file`, body, headers);
      return result.data;
    },
    raiseApprove: async (id: string) => {
      const result = await http.patch(
        `/raise/${id}/approve`,
        {},
        {
          headers,
        },
      );
      return result.data;
    },
    raiseRepprove: async (id: string) => {
      const result = await http.patch(
        `/raise/${id}/repprove`,
        {},
        {
          headers,
        },
      );
      return result.data;
    },
    bonusesCreate: async (body: any) => {
      const result = await http.post(`/bonuses`, body, { headers });
      return result.data;
    },
    bonusesApprove: async (bonusesId: string) => {
      const result = await http.patch(`/bonuses/${bonusesId}/approve`, {}, { headers });
      return result.data;
    },
    bonusesReject: async (bonusesId: string) => {
      const result = await http.patch(`/bonuses/${bonusesId}/reject`, {}, { headers });
      return result.data;
    },
    bonusesList: async (schoolId: string, _search = '', params?: Record<string, any>) => {
      const queryString = params ? `?${new URLSearchParams(params).toString()}` : '';
      const result = await http.get(`/cover-sheet/${schoolId}/bonuses${queryString}`, {
        headers,
      });
      return result.data;
    },
    coverSheetList: async (schoolId: string, query?: string) => {
      const result = await http.get(`/cover-sheet/by-school/${schoolId}${query ? `?${query}` : ''}`, {
        headers,
      });
      return result.data;
    },
    coverSheetBonuses: async (schoolId: string, params?: Record<string, any>) => {
      const queryString = params ? `?${new URLSearchParams(params).toString()}` : '';
      const result = await http.get(`/cover-sheet/${schoolId}/bonuses${queryString}`, { headers });
      return result.data;
    },
    coverSheetDeductions: async (schoolId: string, params?: Record<string, any>) => {
      const queryString = params ? `?${new URLSearchParams(params).toString()}` : '';
      const result = await http.get(`/cover-sheet/${schoolId}/deductions${queryString}`, { headers });
      return result.data;
    },
    coverSheetExtraPayments: async (schoolId: string, params?: Record<string, any>) => {
      const queryString = params ? `?${new URLSearchParams(params).toString()}` : '';
      const result = await http.get(`/cover-sheet/${schoolId}/extra-payments${queryString}`, { headers });
      return result.data;
    },
    coverSheetRaises: async (schoolId: string, params?: Record<string, any>) => {
      const queryString = params ? `?${new URLSearchParams(params).toString()}` : '';
      const result = await http.get(`/cover-sheet/${schoolId}/raises${queryString}`, { headers });
      return result.data;
    },
    coverSheetTerminatedEmployees: async (schoolId: string, params?: Record<string, any>) => {
      const queryString = params ? `?${new URLSearchParams(params).toString()}` : '';
      const result = await http.get(`/cover-sheet/${schoolId}/terminated-employees${queryString}`, { headers });
      return result.data;
    },
    coverSheetNewEmployees: async (schoolId: string, params?: Record<string, any>) => {
      const queryString = params ? `?${new URLSearchParams(params).toString()}` : '';
      const result = await http.get(`/cover-sheet/${schoolId}/new-employees${queryString}`, { headers });
      return result.data;
    },
    coverSheetGetStatus: async (schoolId: string, periodStart: string, periodEnd: string) => {
      const params = new URLSearchParams({ periodStart, periodEnd });
      const result = await http.get(`/cover-sheet/${schoolId}/status?${params.toString()}`, { headers });
      return result.data;
    },
    coverSheetApprove: async (schoolId: string, data: { periodStart: string; periodEnd: string; notes?: string }) => {
      const result = await http.post(`/cover-sheet/${schoolId}/approve`, data, { headers });
      return result.data;
    },
    coverSheetReject: async (
      schoolId: string,
      data: { periodStart: string; periodEnd: string; rejectionReason: string; notes?: string },
    ) => {
      const result = await http.post(`/cover-sheet/${schoolId}/reject`, data, { headers });
      return result.data;
    },
    coverSheetSubmit: async (schoolId: string, data: { periodStart: string; periodEnd: string }) => {
      const result = await http.post(`/cover-sheet/${schoolId}/submit`, data, { headers });
      return result.data;
    },
    timecardList: async (schoolId: string, params?: Record<string, any>) => {
      const queryString = params ? `?${new URLSearchParams(params).toString()}` : '';
      const result = await http.get(`/timecards/${schoolId}${queryString}`, { headers });
      return result.data;
    },
    timecardListWithPending: async (schoolId: string, params?: Record<string, any>) => {
      const queryString = params ? `?${new URLSearchParams(params).toString()}` : '';
      const result = await http.get(`/timecards/${schoolId}/with-pending${queryString}`, {
        headers,
      });
      return result.data;
    },
    payrollDownload: async (
      schoolId: string,
      periodStart: string,
      periodEnd: string,
      format: 'zip' | 'xlsx' = 'zip',
    ) => {
      const params = new URLSearchParams({ periodStart, periodEnd, format });
      const result = await http.get(`/cover-sheet/${schoolId}/download?${params.toString()}`, {
        headers,
      });
      return result.data;
    },
  };
};

export default Payroll;
